export default {
  "How do I edit a category?": ["Ask it nicely!"],
  "When is the sun going to rise?": ["All depends on your eyes!"],
};



// WEBPACK FOOTER //
// ./dev/src/questions.js